import ComplaintView from './containers/ComplaintView';
import React from 'react';

export default ComplaintView;

export {uiDataComplaintView, serverDataComplaintView} from './reducers/ComplaintView';